import { useQuery } from '@tanstack/react-query';
import { DocumentsService } from 'api';
import {
  FIRM_DOCUMENT_FOLDERS_QUERY_KEY,
  FIRM_DOCUMENT_FOLDERS_QUERY_STALE_TIME_MS,
} from './useFirmDocumentFoldersQuery.constants';
import type { UseFirmDocumentFoldersQueryParams } from './useFirmDocumentFoldersQuery.types';

export const useFirmDocumentFoldersQuery = ({
  companyId = null,
  enabled = true,
  firmId,
  measurementDateId = null,
}: UseFirmDocumentFoldersQueryParams) => {
  const resolvedMeasurementDateId = measurementDateId ?? 0;

  return useQuery({
    enabled: Boolean(firmId && resolvedMeasurementDateId && enabled),
    queryFn: () => DocumentsService.apiDocumentsFirmsMeasurementDatesFoldersList(
      String(firmId),
      String(resolvedMeasurementDateId),
      companyId ?? undefined
    ),
    queryKey: [
      FIRM_DOCUMENT_FOLDERS_QUERY_KEY,
      firmId,
      resolvedMeasurementDateId || '',
      companyId ?? '',
    ],
    staleTime: FIRM_DOCUMENT_FOLDERS_QUERY_STALE_TIME_MS,
  });
};
